<template>
  <div id="raw-time-entries" v-if="isSignedIn">
    <a-table
            :columns="columns"
            :data-source="rawTimeEntries"
            class="components-table-demo-nested"
            :pagination="false"
            :rowKey="record => record.batch_id + record.coalesced_time_entry_id + record.id"
            :loading="isLoading"
    >
        <div class="center-col" slot="workspace_id" slot-scope="value">{{value}}</div>
        <div class="center-col" slot="story_id" slot-scope="value">{{value}}</div>
        <div class="center-col" slot="hours" slot-scope="value">{{getEntryHours(value)}}
        </div>
        <div class="center-col" slot="approved" slot-scope="value">{{value ? "Approved" : "Not Approved"}}</div>
    </a-table>
  </div>

</template>
<script>
  import { mapState, mapGetters, mapMutations} from "vuex";
  import axios from "axios";

  const columns = [
    {
      title: "Workspace ID",
      dataIndex: "workspace_id",
      key: "workspace_id",
      scopedSlots: { customRender: "workspace_id" }
    },
    {
      title: "Story ID",
      dataIndex: "story_id",
      key: "story_id",
      scopedSlots: { customRender: "story_id" }
    },
    {
      title: "No. of Hours",
      dataIndex: "time_in_minutes",
      key: "hours",
      scopedSlots: { customRender: "hours" }
    },
    {
      title: "Status",
      dataIndex: "approved",
      key: "approved",
      scopedSlots: { customRender: "approved" }
    },
  ];

  export default {
    name: "RawTimeEntries",
    computed: {
      ...mapState(["apiUrl"]),
      ...mapGetters('auth', ["isSignedIn","getUUID"]),
    },
    data() {
      return {
        columns,
        rawTimeEntries: [],
        isLoading: false,
      };
    },
    methods: {
      ...mapMutations('auth', ["signInFailed"]),
      fetchRawTimeEntries() {
        this.isLoading = true;
        axios({
          url: `${this.apiUrl}/getBatchEntries`,
          params: {
            action: "FETCH_RAW_TIME_ENTRIES",
            batchId: this.batchId,
            workdayEmpId: this.workdayEmpId,
            datePerformed: this.datePerformed,
            entryType: this.entryType,
            ptoSubtype: this.ptoSubtype,
          },
          headers: {
            Authorization: 'Bearer ' + this.getUUID
          }
        })
          .then(rslt => {
            this.rawTimeEntries = rslt.data;
            this.isLoading = false;
          })
          .catch(err => {
            //In the case the endpoint returns a 401, that means
            // our session token has expired. Reroute to /sso-login
            if(err.response.status == 401) {
              this.signInFailed("Session has expired.");
              this.$router.push(`/sso-login`);
            }
            else {
              alert("Unable to load entries");
              this.isLoading = false;
            }
          });
      },
      // Round-up to 2 decimal places
      getEntryHours(minutes) {
        return Math.round((minutes / 60) * 100) / 100;
      },
    },
    mounted() {
      this.isLoading = true;
      this.fetchRawTimeEntries();
    },
    props: ["batchId", "workdayEmpId", "datePerformed", "entryType", "ptoSubtype"]
  }
</script>

<style lang="scss" scoped>
  ::v-deep {
    .ant-table-thead > tr > th,
    .center-col {
      text-align: center;

      &[key="PageName"] {
        text-align: left;
      }
    }

    .clickable {
      cursor: pointer;
    }
  }
</style>